exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-overlay[data-v-3d84fc0e]{position:absolute;width:100%;height:100%;top:0;left:0;opacity:.7;background:#000;z-index:5000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d84fc0e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loader.vue
// module id = 288
// module chunks = 0